module.exports = global.config = {
    api_server: "https://tour-admin.solvifytech.com/v1/",
    asset_server: "https://tour-admin.solvifytech.com",
    public_server: "https://tour.solvifytech.com",
    items_per_page: 20,
    settings_token: "title",
};